import { StyleAttribute } from 'glamor';

class StyleCacheInstance {
	private cache: ICacheItem[] = [];

	Lookup(cssHash: string) {
		const cachedItem = this.cache.find((item) => item.cssHash === cssHash);
		return cachedItem ? cachedItem.css : undefined;
	}

	Add(cssHash: string, css: StyleAttribute) {
		const newCacheItem: ICacheItem = { cssHash, css };
		this.cache.push(newCacheItem);
	}
}

export const StyleCache = new StyleCacheInstance();

interface ICacheItem {
	cssHash: string;
	css: StyleAttribute;
}
